import React from "react";
import { motion } from "framer-motion";
import goldenBg from "../assets/images/goldenbg.png";
import hueImg from "../assets/images/hue.png";
import robertImg from "../assets/images/robert.png";
import girishImg from "../assets/images/girish.png";

const Leadership = () => {
  const leaders = [
    {
      name: "Hue Nguyen",
      role: "GP",
      image: hueImg,
      bio: "A global strategic advisor and impact-driven investor with deep expertise at the intersection of fintech, SEC regulation, and tokenization of real-world asset (RWA) infrastructure. With experience spanning Web3 and TradFi ecosystems.",
        bio2: "Hue brings a rare blend of regulatory insight, capital markets understanding, and hands-on execution across alternative and traditional asset classes.",
    },
    {
      name: "Robert D. Sudon",
      role: "GP",
      image: robertImg,
      bio: "A strategic & saleforce business development advisor in the focus areas of medical technology, construction project management and real estate deals, commodities, manufacturing and supply chain logistics.",
      bio2: "Bobby was instrumental in the growth of his family office business & Sudon Brothers Construction Company in the commercial and residential side. His distinguished career as an industry leader, architect mind and progressive idealist.",
    },
    {
      name: "Girish Ahirwar",
      role: "GP",
      image: girishImg,
      bio: "A serial entrepreneur, angel investor, and strategic advisor with over a decade of experience building and scaling technology-led ventures across Web2, Web3, AI, and fintech.",
        bio2: "With 2 successful exits, Girish actively advises and partners with global startups and platforms  focusing on blockchain, fundraising, investor relations, and cross-border strategy.",
    },
  ];

  
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-[#121212] py-20 px-4 md:px-10">
     
      <motion.div 
        initial={{ scale: 1.1, opacity: 0 }}
        whileInView={{ scale: 1, opacity: 0.4 }}
        transition={{ duration: 2 }}
        className="absolute inset-0 z-0"
      >
        <img
          src={goldenBg}
          alt="Background"
          className="h-full w-full object-cover"
        />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-7xl">
      
        <motion.h2 
          initial={{ y: -20, opacity: 0 }}
          whileInView={{ y: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="mb-16 text-center font-['NanumMyeongjo'] text-4xl uppercase tracking-[0.2em] text-[#EAE2C3] md:text-5xl font-regular font-light"
        >
          Our Leadership
        </motion.h2>

        
        <motion.div 
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3"
        >
          {leaders.map((leader, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="group relative flex flex-col items-center border border-[#EAE2C3] bg-[#0A0A0A]/80 p-6 md:p-8 text-center transition-all duration-300 hover:border-[#C09462]"
            >
              <div className="mb-6 h-40 w-40 overflow-hidden rounded-full ">
                <img
                  src={leader.image}
                  alt={leader.name}
                  className="h-full w-full object-cover transition-all duration-500"
                />
              </div>

              <h3 className="mb-2 font-['Nalieta'] text-2xl text-[#C09462] sm:text-3xl md:text-4xl">
                {leader.name}
              </h3>
              <p className="mb-6 font-['Nalieta'] text-lg font-regular text-[#EAE2C3] sm:text-xl md:text-2xl">
                {leader.role}
              </p>

              <p className="text-center font-['Nalieta'] text-sm leading-relaxed text-[#EAE2C3] md:text-base">
                {leader.bio}
              </p>
              <p className="mt-4 text-center font-['Nalieta'] text-sm leading-relaxed text-[#EAE2C3] md:text-base">
                {leader.bio2}
              </p>
            </motion.div>
          ))}
        </motion.div>

        
        <motion.div 
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
          className="mt-16 flex justify-center md:justify-start"
        >
          <a 
            href="https://www.maxtron.ai/our-team" 
            target="_blank" 
            rel="noopener noreferrer"
            className="relative z-50 flex items-center gap-4 bg-[#C09462]/80 px-8 py-3 font-['SF_Pro_Display'] text-lg font-medium text-white transition-all hover:bg-[#C09462] group cursor-pointer"
          >
            Our Team 
            <motion.span
              whileHover={{ x: 5 }}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16 5C16 5.742 16.733 6.85 17.475 7.78C18.429 8.98 19.569 10.027 20.876 10.826C21.856 11.425 23.044 12 24 12M24 12C23.044 12 21.855 12.575 20.876 13.174C19.569 13.974 18.429 15.021 17.475 16.219C16.733 17.15 16 18.26 16 19M24 12H0" stroke="white" strokeWidth="2"/>
              </svg>
            </motion.span>
          </a>
        </motion.div>
      </div>
    </div>
  );
};

export default Leadership;
